import React, {useContext, useEffect, useRef, useState } from 'react';
import { Dialog, Switch, Item } from '@zebra-fed/zds-react-desktop';
import styled from 'styled-components';
import Snackbar from '@material-ui/core/Snackbar';
import {SnackbarContent} from "../../styled-components/shared";
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import {getEodCategories,EOD_CATEGORIES} from '../../data/constants'
import { useTranslation } from "react-i18next";
import Select from '@material-ui/core/Select';
import { SiteModel, SiteService} from "../../Services/SiteService";
import { ServerStyleSheets } from '@material-ui/core';
import { DataContext } from '../../data/DataContext';
import {TimeZoneData} from "../../data/tzTimeZoneList";
import { SiteReportedTime } from "./EditSiteModal";

import {StyledField, StyledTextField, LabelText, ErrorLine, HeadDes, BodyContent, Formcontainer, SelectField, PopupContainer, FooterContainer, PopupHeader, TransBtn, BlueBtn } from "./Styles";
import Checkbox from '@material-ui/core/Checkbox';
import {isIPAddress} from 'ip-address-validator';
import { FormControl, FormGroup, FormControlLabel, Typography, Link } from '@material-ui/core';

import { Button, RadioButtonGroup } from "@zebra-fed/zds-react-desktop";


const SwitchDiv = styled.div`
  padding-left: 50px;
  left: 0px;
`;

const NoBullets = styled.div`
margin: 0;
padding: 20;
list-style-type: none;
overflow-y: scroll;
height:200px;
width:300px;
border: 1px solid Silver;`;

class SiteProps {
    
    modalRef;

   
    tenantId;

    //Callback when a device is added
    onSiteAdded;
}

export  function AddSiteModal(args) {
    
     
    var props = new SiteProps();
    props = args;

    const dialogRef = props.modalRef;
    const data = props.data;
    const {deviceRegistrationType} = props.appSetting;
    const { t} = useTranslation();
    const [isLoading, setIsLoading] = useState(false);

    const errors = useRef([]);
    const [hasErrors, setHasErrors] = useState(false);
    // DLR flag enableBTScannerTracking
    const { dlrFeatureFlag, mlPredictionStatus, globalAppSettings } = useContext(DataContext);
    const [showDLR, setShowDLR] = useState(false);


    const service = new SiteService();
    

    const [model, setModel] = useState({
        siteName: "",
        timeZone: "",

        scheduledReportTime: null,
        emailSubscribed: false,

        emailList:"",

        snapshotReportCategories : {
                'Select All' : false ,
                'Never Connected': false,
                'Disconnected': false,
                'Checked Out': false,
                'Low Battery': false,
                'Charging': false,
                'Decommissioned': false,
                'Discharging': false,
                'Idle': false,
                'At Risk': false,
                'To Be Found': false,
                'Being Found': false,
                'Cannot Find': false,
                'Found': false,
                'Move In/Out':false,
                [EOD_CATEGORIES["CONNECTED ACCESSORIES"]]:false
            },
            attachCSV: false
    });
    
    const isManager = props.isManager;
    //Default site assigned if manager
    const assignedSite = props.assignedSite;
    
    const tenantId = props.tenantId;
 
    const onSiteAdded = props.onSiteAdded;
    console.log("enableBTScannerTracking",DataContext)
    const categoriesData = getEodCategories(globalAppSettings.enableBTScannerTracking);
    
    const TIME_AM = 1;
    const TIME_PM = 2;

    useEffect(() => {
        console.log("categoriesData ", categoriesData, dlrFeatureFlag)
        if(!dlrFeatureFlag){
          // removing At Risk if dlr feature is disabled
          setShowDLR(false);
        }
        else{
          if(mlPredictionStatus)  setShowDLR(true);    // adding At Risk if ml prediction enabled
          else  setShowDLR(false);
        }
    }, [mlPredictionStatus, dlrFeatureFlag]);

    useEffect(() => {
        clearForm();
    }, [""]);

    function clearForm() {
        
       setModel({
            siteName: "",
            timeZone: "",

            scheduledReportTime: null,
            emailSubscribed: false,
            startIPAddress:"",
            endIPAddress:"",

            emailList:"",
            snapshotReportCategories : {
                'Select All' : false ,
                'Never Connected': false,
                'Disconnected': false,
                'Checked Out': false,
                'Low Battery': false,
                'Charging': false,
                'Decommissioned': false,
                'Discharging': false,
                'Idle': false,
                'At Risk': false,
                'To Be Found': false,
                'Being Found': false,
                'Cannot Find': false,
                'Found': false,
                'Move In/Out':false,
                [EOD_CATEGORIES["CONNECTED ACCESSORIES"]]:false
            },
            attachCSV: false

       });

        //Clear the errors
        errors.current = [];
    }

    function validateRequired(value, fieldName, validationMsgKey){
            if(fieldName === "scheduledReportTime"){
                if (value == null) {
                    //Add the required error against the field name
                    errors.current.push({"fieldName": fieldName, "errorMessage":  t(validationMsgKey)});
                }
            }else{
                if (value == null || value.trim() == "") {
                    //Add the required error against the field name
                    errors.current.push({"fieldName": fieldName, "errorMessage":  t(validationMsgKey)});
                }
            }
            
    }

    function validateFieldLength(value, fieldName, maxLength, validationMsgKey){
     
        if(value == null) {
            //NULL value. No need for futher validation
            return;
        }

        if (value.length > maxLength) {
            //Add the MAX length Error  against the field name
            errors.current.push({"fieldName": fieldName, "errorMessage": t(validationMsgKey)});
            //errors[fieldName] = "Please provide a value with length less than " + maxLength;
        }
    }

    function validateDuplicateSite(value, fieldName,validationMsgKey){
        const siteNames = data.map(row=>row.siteName.toLowerCase());
        if(siteNames.indexOf(value.toLowerCase()) !=-1){
            errors.current.push({"fieldName": fieldName, "errorMessage": t(validationMsgKey)});
        }
        return
    }

    function validateFormat(value, fieldName, validationMsgKey){
        console.log('isIPAddress(value) '+isIPAddress(value))
        if(!isIPAddress(value)){
            errors.current.push({"fieldName": fieldName, "errorMessage": t(validationMsgKey)});
        }
        return;
    }

    async function validateSite(){
        errors.current = [];

        const MAX_CHARS = 32;
        const MAX_CHARS_MSG_KEY = "validation.rules.sso.rule45";
        const REQUIRED_TXT_MSG_KEY = "validation.rules.Mo_Dash.RequiredTxtMessage";
        const REQUIRED_DROPDOWN_MSG_KEY = "validation.rules.Mo_Dash.RequiredDropdownMessage";
        const EMAIL_INAVLID_KEY = "validation.rules.sso.rule46";
        const DUPLICATE_NOT_ALLOWED_KEY = "validation.rules.sso.rule49"
        const INVALID_IP_TXT_MSG_KEY = "validation.rules.Mo_Dash.InvalidIPAddress"
        const INVALID_IP_RANGE = "validation.rules.Mo_Dash.InvalidIPAddressRange"
        const IP_ADDRESS_OVERLAP = "validation.rules.Mo_Dash.IpAddressOverlap"

        //Validate each field
        //All the fields have the same MAX length. So use the same ERR MSG & MAX CHARS
        validateRequired(model.siteName, "siteName", REQUIRED_TXT_MSG_KEY);
        validateFieldLength(model.siteName, "siteName", MAX_CHARS, MAX_CHARS_MSG_KEY);

        validateRequired(model.timeZone, "timeZone", REQUIRED_DROPDOWN_MSG_KEY);
        validateDuplicateSite(model.siteName, "siteName", DUPLICATE_NOT_ALLOWED_KEY);
        if(model.emailSubscribed){
            validateRequired(model.scheduledReportTime, "scheduledReportTime", REQUIRED_TXT_MSG_KEY);
        }


        //Device to site Assignment based on Ip Address

        if(deviceRegistrationType === 2) {
            validateRequired(model.startIPAddress, "startIPAddress", REQUIRED_TXT_MSG_KEY);
            validateFormat(model.startIPAddress, "startIPAddress", INVALID_IP_TXT_MSG_KEY);

            validateRequired(model.endIPAddress, "endIPAddress", REQUIRED_TXT_MSG_KEY);
            validateFormat(model.endIPAddress, "endIPAddress", INVALID_IP_TXT_MSG_KEY);

            console.log("startIPAddress", model.startIPAddress)
            console.log("endIPAddress", model.endIPAddress)
            console.log('errors.current '+JSON.stringify(errors.current))

            let errorsInIPInput = errors.current.filter(el=>{
               return  el.fieldName === 'startIPAddress' || el.fieldName === 'endIPAddress'
            })
            console.log('errorsInIPInput '+JSON.stringify(errorsInIPInput))

            //Invalid IP Range
            if(errorsInIPInput.length === 0){
                if(!SiteService.isValidIPRange(model.startIPAddress, model.endIPAddress)){
                    console.log('Valid Range')
                    errors.current.push({"fieldName": "startIPAddress", "errorMessage":  t(INVALID_IP_RANGE)});
                    errors.current.push({"fieldName": "endIPAddress", "errorMessage":  t(INVALID_IP_RANGE)});
                }else{
                    const res = await service.ipRangeOverlapping(model.startIPAddress, model.endIPAddress, data);
                    if(res){
                        errors.current.push({"fieldName": "startIPAddress", "errorMessage":  t(IP_ADDRESS_OVERLAP)});
                        errors.current.push({"fieldName": "endIPAddress", "errorMessage":  t(IP_ADDRESS_OVERLAP)});
                    }
                }
            }
        }


     
        //Validate Email
        if(! SiteService.isValidEmailList(model.emailList)){
            //Email Invalid
            errors.current.push({"fieldName": "emailList", "errorMessage":  t(EMAIL_INAVLID_KEY)});
        }


        if(model.scheduledReportTime != null){
            //Reported time can contain only 00/30 in MINS
            if(model.scheduledReportTime.minutes != "00" && model.scheduledReportTime.minutes !="30" ){
                //Validate
                errors.current.push({"fieldName": "scheduledReportTime",
                    errorMessage: t("validation.rules.Mo_Dash.InvalidScheduledTime")});
            }
        }

        setHasErrors(!hasErrors);
    }
 
    function getErrorMessage(field) {
        
        const error = errors.current.find((error) => error.fieldName == field);
        return error ? error.errorMessage: null;
    }



    function handleCancel() {

        //Clear the form and close it
        clearForm();
        dialogRef.current.toggleDialog();
        // clearForm();
    }

    const ButtonStyle = {
        cursor: isLoading ? 'wait' : 'pointer',
    }

    async function handleAddClick() {
        
        await validateSite();
        //dialogRef.current.toggleDialog();
 
        if(errors.current.length == 0){
            //No errors..
            //Add to DB
            
            setIsLoading(true);

          
            //Add the DEVICE
            await service.addSite(tenantId, model);

            //Just call the function It will take care of refreshing the UI  
            await onSiteAdded();
            setIsLoading(false);

             //Clear the form and close it
            clearForm();

            //close the dialog
            dialogRef.current.toggleDialog();
            
        }
    }


    function renderErrorMessage(fieldName){
        var errMsg = getErrorMessage(fieldName);

        return  (<ErrorLine style={{  display: errMsg != null ? 'block' : 'none' }}>
        { errMsg }
    </ErrorLine>);
    }

    const handleOnChange = (category) => {
        const updatedCheckedState = model.snapshotReportCategories;
        if(category==="Select All")
        {
            let final = !updatedCheckedState[category];
            for(let key in updatedCheckedState)
            {
                updatedCheckedState[key] = final;
            }
        }
        else
        {
            updatedCheckedState[category] = !updatedCheckedState[category];
            if(updatedCheckedState[category] == false)
            {
                updatedCheckedState["Select All"] = false;
            }
            if(updatedCheckedState['Never Connected'] && updatedCheckedState['Disconnected'] && updatedCheckedState['Checked Out'] && updatedCheckedState['Low Battery'] && updatedCheckedState['Charging'] && updatedCheckedState['Decommissioned'] && updatedCheckedState['Discharging'] && updatedCheckedState['Idle'] && updatedCheckedState['To Be Found'] && updatedCheckedState['Being Found'] &&updatedCheckedState['Cannot Find'] && updatedCheckedState['Found'] && updatedCheckedState['At Risk'] && updatedCheckedState['Move In/Out'] && updatedCheckedState[EOD_CATEGORIES["CONNECTED ACCESSORIES"]] ){
                updatedCheckedState['Select All'] = true;
            }
        }
        console.log(updatedCheckedState);
        setModel({ ...model, snapshotReportCategories: updatedCheckedState });
        };

    const handleattachCSV = () => {
        setModel({...model, attachCSV: !model.attachCSV});
        console.log(model.attachCSV);
    };


    
    const timeZones = TimeZoneData;

    function convertToBoolean(value){
        if(value == null || value == "") {
            return null;
        }
        else {
            return (value == "true");
        }
    }

    return (
        <div>  
            <Dialog
                ref={dialogRef} 
                key='dialog255'
                width='520px'
                headerStyle={{ display: 'none' }}
                bodyStyle={{ padding: '0px', width: '100%' }}
                cardStyle={{ marginBottom: '20px' }}
                footerStyle={{ display: 'none' }}
                items={[]}>
              <PopupContainer>
                <PopupHeader>{t('site.addTitle')}</PopupHeader>
                <HeadDes>{t('manual')}</HeadDes>
                <BodyContent>
                    <form noValidate onSubmit={handleAddClick}
                        style={{ pointerEvents: isLoading ? 'none' : '' }}>
                   
                        <Formcontainer>
                            <LabelText>{t('site.siteName')}</LabelText>
                            <StyledTextField
                                id='outlined-basic'
                                variant="outlined"
                                error={ getErrorMessage("siteName") }
                                onChange={(e) => setModel({ ...model, siteName: e.target.value })}
                                placeholder={t('Mo_Dash.placeholders.enter_siteName')}
                                value={model.siteName}
                               
                            />
                             {  renderErrorMessage("siteName") }
                        </Formcontainer>
                        {
                            deviceRegistrationType === 2 && <>
                             <Formcontainer>
                                <LabelText>{t('site.startIPAddress')}</LabelText>
                                <StyledTextField
                                    id='outlined-basic'
                                    variant="outlined"
                                    error={ getErrorMessage("startIPAddress") }
                                    onChange={(e) => setModel({ ...model, startIPAddress: e.target.value })}
                                    placeholder="Start IP Address"
                                    value={model.startIPAddress}

                                />
                                {  renderErrorMessage("startIPAddress") }
                            </Formcontainer>

                            <Formcontainer>
                                <LabelText>{t('site.endIPAddress')}</LabelText>
                                <StyledTextField
                                    id='outlined-basic'
                                    variant="outlined"
                                    error={ getErrorMessage("endIPAddress") }
                                    onChange={(e) => setModel({ ...model, endIPAddress: e.target.value })}
                                    placeholder="End IP Address"
                                    value={model.endIPAddress}

                                />
                                {  renderErrorMessage("endIPAddress") }
                            </Formcontainer>
                            </>
                        }

                        
                        <Formcontainer>
                            <LabelText>{t('site.timeZone')}</LabelText>
                            <SelectField
                                native
                                variant="outlined"
                                value={model.timeZone}
                                onChange={(e) => setModel({ ...model, timeZone: e.target.value })
                                }
                                error={ getErrorMessage("timeZone")}>
                                <option value={null}>{t('Select')}</option>
                                {
                                    timeZones.map((tz) => {
                                        return (<option value={tz.tzDatabaseName}>{tz.tzDatabaseName}</option>);
                                    })
                                }
                            </SelectField>
                            {  renderErrorMessage("timeZone") }
                        </Formcontainer>


                        <Formcontainer>
                            <FormControlLabel
                                    classes="onOffSwitch"
                                    control={<SwitchDiv> 
                                        <Switch color="primary" 
                                            checked={model.emailSubscribed} value={model.emailSubscribed} 
                                            onChange={(value) => setModel({ ...model, emailSubscribed: value })}
                                                /> 
                                        </SwitchDiv>}
                                    label={<LabelText>{t('site.emailSubscribed')}</LabelText>}
                                    labelPlacement="start" 
                                    style={{   marginLeft: '0',  float: 'left'}}/>
                        </Formcontainer>   
                        
                        {model.emailSubscribed &&
                        <Formcontainer>
                            <SiteReportedTime  reportTime={model.scheduledReportTime}
                                onReportingTimeChanged ={
                                (reportTime) => {
                                    //Update the Model
                                    setModel({
                                        ...model,
                                        scheduledReportTime: reportTime
                                    });
                                }
                            } />
                            {renderErrorMessage("scheduledReportTime")}
                        </Formcontainer>
                        }


                        { /* 05/05: Internal Bugfix. Show emailList only when emailSubscrion is YES */}
                        { (model.emailSubscribed) &&
                        <Formcontainer>
                            <LabelText>{t('site.emailList')}</LabelText>
                            <StyledTextField 
                                rows={2} 
                                maxRows={2}
                                multiline={true}
                                id='outlined-basic'
                                variant="outlined"
                                error={ getErrorMessage("emailList") }
                                onChange={(e) => setModel({ ...model, emailList: e.target.value })}
                                placeholder={t('Mo_Dash.placeholders.enter_email')}
                                value={model.emailList}
                               
                            />
                          {  renderErrorMessage("emailList") }
                        </Formcontainer>
                        }
                        
                        <Formcontainer>
                            <LabelText>{t('site.emailCriteria')}</LabelText>
                            <div
                                id='outlined-basic'
                                variant="outlined"
                                value={model.snapshotReportCategories}
                                error={ getErrorMessage("emailCriteria")}>
                                <NoBullets>
                                {categoriesData.map((category, index) => {
                                    if(category.value == "At Risk" && !showDLR){
                                        return null;
                                    }
                                    return (
                                        <li key={index}>
                                            <div>
                                              <Checkbox
                                                name={category.value}
                                                value={category.value}
                                                checked={model.snapshotReportCategories[category.value] }
                                                onChange={() => handleOnChange(category.value)}
                                              />
                                              <label>{category.label}</label>
                                            </div>
                                        </li>
                                    );
                                })}
                                </NoBullets>
                            </div>
                            {  renderErrorMessage("emailCriteria") }
                        </Formcontainer>
                        
                        {model.emailSubscribed?
                        <Formcontainer>
                            <div className="Attachments">
                                <Checkbox
                                checked={model.attachCSV}
                                onChange={handleattachCSV}
                                />
                                {t('site.attachCSV')}
                            </div>
                        </Formcontainer>
                        :
                        <Formcontainer>
                            <div className="Attachments">
                                <Checkbox
                                checked={model.attachCSV}
                                onChange={handleattachCSV}
                                disabled
                                />
                                {t('site.attachCSV')}
                            </div>
                        </Formcontainer>
                        }



                    </form>
                </BodyContent>
                <FooterContainer style={{ pointerEvents: isLoading ? 'none' : '' }}>
                    <TransBtn onClick={() => { handleCancel() }}>{t('cancel')}</TransBtn>
                    <BlueBtn onClick={ handleAddClick  }>{ isLoading ? t('workingOnIt') : t('Confirm')}</BlueBtn>
                </FooterContainer>
                </PopupContainer>
              
            </Dialog>
        </div>
    ) 
} 